import React from 'react'

const Linkedin = (props:any) :JSX.Element => {
  return (
<svg width="39" height="36" viewBox="0 0 39 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.18468 4.00178C8.18414 5.06258 7.75246 6.07973 6.98461 6.82946C6.21677 7.57919 5.17565 8.00009 4.09029 7.99956C3.00494 7.99903 1.96425 7.57711 1.19717 6.82663C0.430093 6.07616 -0.000542166 5.05859 5.12282e-07 3.99778C0.00054319 2.93697 0.43222 1.91982 1.20007 1.17009C1.96791 0.420365 3.00903 -0.000529903 4.09439 5.00695e-07C5.17974 0.000530904 6.22043 0.422443 6.98751 1.17292C7.75459 1.9234 8.18522 2.94097 8.18468 4.00178ZM8.30745 10.9614H0.122771V36H8.30745V10.9614ZM21.2392 10.9614H13.0955V36H21.1574V22.8607C21.1574 15.5411 30.9176 14.8612 30.9176 22.8607V36H39V20.1409C39 7.80157 24.554 8.26154 21.1574 14.3212L21.2392 10.9614Z" fill={props.Fill ? props.Fill :"#262626"}/>
</svg>

    
  )
}

export default Linkedin